import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import {
  calculateKickoffYardage,
  calculateReturnYardage,
} from "../../../../helpers/helpers";
import { PlayerSelection } from "../Components/PlayerSelection";
import { RosterPlayer } from "../../../../types/LogTypes";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { YardlineInput } from "../Components/YardlineInput";

export const KickOffReturnLog = () => {
  const { setCurrentPlayLog, clearSelections, currentPlayLog } = useLogger();
  const { kickOffReturners } = useDepthChart();
  const [selectedReturner, setSelectedReturner] = useState<RosterPlayer | null>(
    null
  );
  const [jerseyNumber, setJerseyNumber] = useState<string>("");
  const [ballCaughtOn, setBallCaughtOn] = useState<number>(0);
  const [ballReturnedTo, setBallReturnedTo] = useState<number>(-20);
  const [kickoffFrom, setKickoffFrom] = useState<number>(40);
  const returnYardage = calculateReturnYardage(ballCaughtOn, ballReturnedTo);
  const kickoffYardage = calculateKickoffYardage(kickoffFrom, ballCaughtOn);

  const handleJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumber(value);
    }
  };

  const handleReturnerSelection = (player: RosterPlayer) => {
    setSelectedReturner(player);
    setJerseyNumber(player.jersey_number?.toString() || "");
  };

  useEffect(() => {
    if (selectedReturner) {
      setCurrentPlayLog({
        returner_roster_player: selectedReturner,
        kickoff_from: kickoffFrom,
        kickoff_to: ballCaughtOn,
        kickoff_yardage: kickoffYardage,
        return_to_yardline: ballReturnedTo,
        return_yardage: returnYardage,
      });
    }
  }, [selectedReturner, kickoffFrom, ballCaughtOn, ballReturnedTo]);

  console.log("current play log", currentPlayLog);

  useEffect(() => {
    if (clearSelections) {
      setSelectedReturner(null);
      setJerseyNumber("");
      setBallCaughtOn(0);
      setBallReturnedTo(-20);
      setKickoffFrom(40);
    }
  }, [clearSelections]);

  return (
    <Box>
      <Grid container>
        {/* Returner */}
        <Grid item xs={4}>
          <PlayerSelection
            title="Returner"
            players={kickOffReturners}
            selectedPlayer={selectedReturner}
            jerseyNumber={jerseyNumber}
            maxDisplayedPlayers={2}
            handlePlayerSelection={handleReturnerSelection}
            handleJerseyNumberChange={handleJerseyNumberChange}
          />
        </Grid>

        {/* Return Yardage */}
        <Grid item xs={8}>
          <Box sx={{ flex: 1 }}></Box>

          <YardlineInput
            value={ballCaughtOn}
            onChange={setBallCaughtOn}
            label="Ball Caught On"
          />
          <YardlineInput
            value={ballReturnedTo}
            onChange={setBallReturnedTo}
            label="Ball Returned To"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" align="center" gutterBottom>
            Return Yardage: {returnYardage} yards
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
